class TwoFactorAuthentication {
  constructor(api) {
    this.api = api;
  }

  generateQRCode(onSuccess, onError) {
    return this.api.http_fibercloud
      .post("v1/2fa/generate")
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  confirmQRCode(data, onSuccess, onError) {
    return this.api.http_fibercloud
      .post("v1/2fa/confirm", data)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  deleteTwoFactorAuthentication(onSuccess, onError) {
    return this.api.http_fibercloud
      .post("v1/2fa/disable")
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }
}
export default TwoFactorAuthentication;



// WEBPACK FOOTER //
// ./src/api/two_factor_authentication.js